var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardBlacklistedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_8424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.01758 28.5312H31.0163V29.5323H-1.01758V28.5312Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98543 29.0305H0.984375V15.0156H6.4902V16.0167H1.98543V29.0305Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0156 29.0305H28.0145V16.0167H23.5098V15.0156H29.0156V29.0305Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0097 29.027H23.0087V4.50106H18.5039V3.5H24.0097V29.027Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99129 29.027H5.99023V3.5H11.4961V4.50106H6.99129V29.027Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2H15.5011V6.00424H14.5V2Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.998 3.5H17.0023V4.50106H12.998V3.5Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0046 8.00847H10.9961V0H19.0046V8.00847ZM11.9972 7.00742H18.0035V1.00106H11.9972V7.00742Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0046 29.0298H18.0035V24.0245H11.9972V29.0298H10.9961V23.0234H19.0046V29.0298Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9984 20.5199H9.99414V16.5156H13.9984V20.5199ZM10.9952 19.5188H12.9973V17.5167H10.9952V19.5188Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0062 20.5199H16.002V16.5156H20.0062V20.5199ZM17.003 19.5188H19.0051V17.5167H17.003V19.5188Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9984 14.512H9.99414V10.5078H13.9984V14.512ZM10.9952 13.511H12.9973V11.5089H10.9952V13.511Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0062 14.512H16.002V10.5078H20.0062V14.512ZM17.003 13.511H19.0051V11.5089H17.003V13.511Z",
    fill: "#E3066F",
    stroke: "#E3066F",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_8424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlacklistedIcon);
export default __webpack_public_path__ + "static/media/dashboard-blacklisted-icon.1dc8692b6e60f09d3252f398b586e717.svg";
export { ForwardRef as ReactComponent };